/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-04-15 15:17:17
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-08 14:42:49
 */
import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import '@/permission'
import api from './api'
import store from './store'
import svgIcon from './components/SvgIcon/index.vue'
import './styles/base.less'
import '@/styles/index.light.less'
import permission from '@/directives/permission'
// store.dispatch('app/setTheme', 'light')

const app = createApp(App)
app.config.globalProperties.$api = api

app.directive('permission', permission)

app.use(store).use(router).component('SvgIcon', svgIcon).mount('#app')
